import { Route } from '@angular/router';

import { routeData } from '@frontend/vanilla/core';

import { CashierComponent } from './cashier.component';
import { cashierGuard } from './cashier.guard';
import { quickDepositGuard } from './quick-deposit/quick-deposit.guard';

export const ROUTES: Route[] = [
    {
        path: ':action',
        component: CashierComponent,
        canActivate: [cashierGuard, quickDepositGuard],
        data: routeData({ authorized: true }),
    },
    {
        path: '',
        component: CashierComponent,
        canActivate: [cashierGuard],
        data: routeData({ authorized: true }),
    },
];
